// JOBE-0165.1: Extracted from AgentDetail.jsx (JOBE-0161.2) so W2 and W5
// share a single source of truth for KPI tile tone selection.
//
// Two helpers:
//   - toneForRate(value, target, direction): rate-vs-target with a 10%
//     warn band.
//       direction='above-ok' → value >= target → ok;
//         value >= target*0.90 → warn; below → bad.
//       direction='below-ok' → value <= target → ok;
//         value <= target*1.10 → warn; above → bad.
//   - toneForDeviation(history): last-value-vs-mean of history.
//       |delta| < 10% → ok; delta < -20% → bad; else warn.

export function toneForRate(value, target, direction) {
  if (direction === 'above-ok') {
    if (value >= target) return 'ok';
    if (value >= target * 0.90) return 'warn';
    return 'bad';
  }
  // below-ok
  if (value <= target) return 'ok';
  if (value <= target * 1.10) return 'warn';
  return 'bad';
}

export function toneForDeviation(history) {
  if (!history || history.length < 2) return 'pencil';
  const mean = history.reduce((a, b) => a + b, 0) / history.length;
  const last = history[history.length - 1];
  const delta = (last - mean) / (mean || 1);
  if (Math.abs(delta) < 0.10) return 'ok';
  if (delta < -0.20) return 'bad';
  return 'warn';
}
